<template>
    <div class="quote form-wrapper">

        <div class="quote-container">
            <el-row v-if="!done" class="flex justify-center" :gutter="30" >

                <el-col :span="24">
                    <el-form :model="quoteForm" :rules="rules" ref="quoteForm">

                        <!-- Contact Information -->
                        <h2 class="no-m">Contact Information</h2>
                        <p class="mt-0 mb-20">The information will be used to contact you about your quote.</p>

                        <el-row :gutter="20" class="mb-20">

                            <el-col :xs="24" :sm="12">
                                <el-form-item prop="first_name">
                                    <el-input placeholder="First Name" v-model="quoteForm.first_name" required></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :xs="24" :sm="12">
                                <el-form-item prop="last_name">
                                    <el-input placeholder="Last Name" v-model="quoteForm.last_name"></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :xs="24" :sm="12">
                                <el-form-item prop="email">
                                    <el-input placeholder="Email" v-model="quoteForm.email" required></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :xs="24" :sm="12">
                                <el-form-item prop="phone">
                                    <el-input placeholder="Phone Number" v-model="quoteForm.phone" required>
                                        <template slot="prepend">{{serviceLocale.phone_prefix}}</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>

                        </el-row>

                        <!-- Service Address -->
                        <h2 class="no-m">Service Address</h2>
                        <p class="mt-0 mb-20">Where would you like us to clean?</p>

                        <el-row :gutter="20" class="mb-20">

                            <el-col :xs="24" :sm="12">
                                <el-form-item prop="street_address">
                                    <el-input placeholder="Street Address" v-model="quoteForm.street_address"></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :xs="24" :sm="12">
                                <el-form-item prop="apt_number">
                                    <el-input placeholder="Apt #" v-model="quoteForm.apt_number"></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :xs="24" :sm="serviceLocale.states ? 8 : 12">
                                <el-form-item prop="city">
                                    <el-input placeholder="City" v-model="quoteForm.city"></el-input>
                                </el-form-item>
                            </el-col>

                            <template v-if="serviceLocale.states">
                                <el-col :xs="24" :sm="8">
                                    <el-form-item prop="selected_state">
                                        <el-select class="w-100" v-model="quoteForm.selected_state" autocomplete="disabled" filterable placeholder="State" style="width: 100%;">
                                            <el-option
                                            v-for="state in serviceLocale.states"
                                            :key="state.abbreviation"
                                            :label="state.name"
                                            :value="state.abbreviation"
                                            style="font-family: 'Inter';"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </template>

                            <el-col :xs="24" :sm="serviceLocale.states ? 8 : 12">
                                <el-form-item prop="zipcode">
                                    <el-input :placeholder=" _placeholder('zipcode') || 'Zip Code'" v-model="quoteForm.zipcode"></el-input>
                                </el-form-item>
                            </el-col>

                        </el-row>

                        <!-- Notes -->
                        <h2 class="mt-0 mb-20">Would you like to add any notes?</h2>

                        <el-row class="mb-20">
                            <el-col :span="24">

                                <el-form-item prop="notes">
                                    <el-input
                                        type="textarea"
                                        :rows="3"
                                        placeholder="Tell us about the property, what special cleaning needs you may have, or any other important information."
                                        v-model="quoteForm.customerNotes">
                                    </el-input>
                                </el-form-item>

                            </el-col>
                        </el-row>

                        <!-- <el-row v-if="error">
                            <div id="warningMessage">
                                <h2><i class="el-icon-warning"></i>Something went wrong</h2>
                                <p>Please fix the errors to complete your quote.</p>
                            </div>
                        </el-row> -->

                        <el-row class="flex">
                            <el-button @click="quote" :loading="spinner_actived" type="primary" class="box grow">
                                <span v-if="!spinner_actived">
                                    Request Quote
                                </span>
                            </el-button>
                        </el-row>

                    </el-form>
                </el-col>

            </el-row>

            <div v-else>
                <formthankyou :client="clientId" :company_logo="companyLogo" :company_name="companyName" />
            </div>
        </div>

    </div>
</template>
<script>


import phoneValidator from 'phone'
import Formthankyou from './thankyou/Formthankyou.vue'

export default {

    props: {
        clientId      : {
            type      : String,
            required  : true
        },
        customer: {
            type: Object
        },
        bookInfo:{
            type: Object
        },
        locationId : {
            type: String,
            required : true,
        },
        customizer:{
            type: Object
        },
        companyName: {
            type     : String,
            required : true
        },
        companyLogo: {
            type: String,
        },
    },

    components: {
        Formthankyou,
    },

    data() {

        var checkNames = (rule, value, callback) => {
            var RegExpression = /^[a-zA-Z\s]*$/;
            if(RegExpression.test(value)) {
                callback();
            } else {
                callback(new Error('Name cannot contain numbers'));
            }
        };

        var checkPhone = (rule, value, callback) => {

            if(value){
                if(phoneValidator(this.phoneWithPrefix,'',true).length) {
                    callback();
                } else {
                    callback(new Error('Invalid Phone Number'));
                }
            }
            else{
                callback(new Error('Phone is required'));
            }
        };

        return {

            done              : false,
            error             : false,
            rules             : {
                email          : [
                    { type:"email", required: true, message: 'Email is required', trigger: 'change' },
                ],
                phone          : [
                    { validator: checkPhone, trigger: 'blur' },
                ],
                zipcode        : [
                    {   trigger: 'blur'},
                    { min: 2, max: 15, message: 'Zipcode lenght error', trigger: 'blur' }
                ],
                last_name      : [
                    { required: true, message: 'Last Name is required', trigger: 'blur' },
                    {validator: checkNames, trigger: 'blue'}
                ],
                first_name     : [
                    { required: true, message: 'First Name is required', trigger: 'blur' },
                    {validator: checkNames, trigger: 'blue'}
                ]
            },

            states            : null,
            quoteForm          : {
                city               : '',
                email              : '',
                hours              : [],
                phone              : '',
                zipcode            : '',
                minutes            : [],
                time_hour          : 'AM',
                last_name          : '',
                first_name         : '',
                apt_number         : '',
                selected_date      : null,
                selected_hour      : null,
                street_address     : '',
                validatedPhone     : null,
                selected_minute    : null,
                customerNotes : '',
            },
            settings          : null,
            book_intent       : '',
            priceBoxTop       : 10,
            customer_id       : '',
            company_name      : '',
            spinner_code      : false,

            serviceLocale     : {
                states:null,
                currency:{}
            },
            spinner_actived   : false,
        };

    },

    created() {

        // Listen for query string params on the parent
        window.addEventListener('message', this.populateInputs);

        let locationNew = (this.locationId != undefined && this.locationId > -1)? this.locationId : 0

        this.$http({
            url: `/booking/booking_form/get_data/` + this.clientId+`/` + locationNew,
            method: 'GET',
        }).then((res) => {

            let data = res.data
            this.settings         = data.settings
            this.company_name     = data.company_name     // Company name for disclaimer
            this.serviceLocale    = data.serviceCurrency  // Country locale configuration

            this.prefillCustomer()

            this.$nextTick(() => this.$emit('ready'))

        }, () => {
            this.$notify.error({
                title: 'Error',
                message: 'There was an error saving the record',
                offset: 100
            })
        });

    },

    watch: {

        'customizer.appearance': {
            deep: true,
            immediate: true,
            handler() {

                if (this.customizer.appearance?.accentColor) {
                    document.querySelector(":root").style.setProperty('--color-primary', this.customizer.appearance.accentColor);
                    document.querySelector(":root").style.setProperty('--input-border-radius', this.customizer.appearance.inputBorderRadius + 'px');
                    document.querySelector(":root").style.setProperty('--form-border-radius', this.customizer.appearance.formBorderRadius + 'px');
                }
            }
        },

    },

    methods: {

        prefillCustomer(){

            if(this.customer){
                this.quoteForm = {...this.quoteForm, ...this.customer}
            }
        },

        // Return the placeholder for the specified input name, if not found return default
        _placeholder(name)
        {
            if(this.serviceLocale.bookForm !== undefined)
                return this.serviceLocale.bookForm[name] || false
        },

        // Load query string vars into the form inputs
        populateInputs(event)
        {
            var app = this

            // Scroll Price box Attempts
            if(event.data.type == 'scroll' ){

                if (Math.abs(event.data.top - this.priceBoxTop ) >= 2) {

                    if(app.clientId == 126)
                        this.priceBoxTop =  event.data.top - 550
                    else
                        this.priceBoxTop =  event.data.top
                }
            }

            if(event.data.type == 'setParams' ){

                var aux_selected = [];

                Object.keys(event.data.params).forEach(function(key){

                    var param = event.data.params[key];

                    this.$set(this.quoteForm, key, param)

                }.bind(this))

                this.$nextTick(tick =>{

                    Object.keys(event.data.params).forEach(function(key){

                        var param = event.data.params[key];
                        var [name, index] = key.split('=')[0].split(/[\[\]]+/)

                    }.bind(app))

                })
            }
        },

        quoteStore()
        {
            var app = this

            let phoneValidated = phoneValidator(app.phoneWithPrefix,'',true);

            app.$http({
                url: `quote_store`,
                method: 'POST',
                data: {
                    city           : app.quoteForm.city,
                    hour           : app.quoteForm.selected_hour,
                    state          : app.quoteForm.selected_state,
                    email          : app.quoteForm.email,
                    phone          : phoneValidated[0],
                    zipcode        : app.quoteForm.zipcode,
                    client_id      : app.clientId,
                    last_name      : app.quoteForm.last_name,
                    first_name     : app.quoteForm.first_name,
                    apt_number     : app.quoteForm.apt_number,
                    selected_date  : app.quoteForm.selected_date,
                    street_address : app.quoteForm.street_address,
                    customer_notes : app.quoteForm.customerNotes,
                }
            }).then((res) => {
                app.error           = false;
                app.done            = true
                app.spinner_actived = false
            }, () => {
                app.spinner_actived = false
                app.$notify.error({
                    title: 'Error',
                    message: 'There was an error saving the record',
                    offset: 100
                })
            })

        },

        quote()
        {
            let app  = this
            app.spinner_actived = true

            this.$refs['quoteForm'].validate((valid, errors) => {
                if (valid) {

                    app.error = false
                    app.quoteStore()

                } else {
                    app.error           = true;
                    app.spinner_actived = false
                    app.$nextTick(() => {
                        document.querySelectorAll('.el-form-item__error')[0].closest(".sectionSeparator").scrollIntoView();
                    })

                    return false;
                }
            });

        }

    },

    computed: {

        phoneWithPrefix()
        {
            return this.serviceLocale.phone_prefix + this.quoteForm.phone;
        },

        currencySymbol()
        {
            return this.serviceLocale.currency[2]
        },

    }
}
</script>

<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');

.el-container{
    font-family: 'Inter' !important;
}

[dir="ltr"] .card-header__title, [dir="ltr"] .h1, [dir="ltr"] .h2, [dir="ltr"] .h3, [dir="ltr"] .h4, [dir="ltr"] .h5, [dir="ltr"] .h6, [dir="ltr"] h1, [dir="ltr"] h2, [dir="ltr"] h3, [dir="ltr"] h4, [dir="ltr"] h5, [dir="ltr"] h6 {
    font-family: 'Inter' !important;
    color:black;
    font-weight: revert;
}

h3{
    font-size: 1.17rem !important;
}

h1,h2,p {
    text-align: center;
    margin-top: 0px;
}

h1,h2 {
    font-family: 'Inter' !important;
    font-weight: 700 !important;
    color: #282828;
    font-size: 1.25rem;
    font-weight: 600 !important;
}

p {
    font-family: 'Inter' !important;
    color: #8492a6;
    font-size: 0.875rem !important;
}

span {
    font-family: 'Inter' !important;
    font-weight: 600 !important;
    /*color:black;*/
}

.el-button--primary {
    background-color: #2F80ED;
    border-color: #2F80ED;
    border-radius: 10px;
}

.form-wrapper {
    margin: 0 auto;
    display: flex;
    justify-content: center;
}

.quote-container span {
    font-family: 'Inter';
    font-weight: 600;
}

.quote-container {
    max-width: 650px !important;
    height: 100%;
    background: white;
    border-radius: 30px;
    padding: 40px;
}

@media (max-width: 500px) {
    .quote-container {
        padding: 30px;
    }
}

.el-input::v-deep, .el-select::v-deep {
    .el-input__inner {
        border: 1px solid #bdbdbd;
        border-radius: 10px;
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 500;
        height: 55px;
        line-height: 40px;
        outline: none;
        padding: 0 15px;
        font-family: "Inter";
    }

    .el-input-group__prepend {
        font-family: 'Inter';
        background-color: #F5F7FA;
        color: #909399;
        vertical-align: middle;
        display: table-cell;
        position: relative;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        padding: 0 20px;
        width: 1px;
        white-space: nowrap;
    }


    .el-input__inner::placeholder, .el-textarea__inner::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #092C4C99;
    }

    .el-input__inner:-ms-input-placeholder, .el-textarea__inner:-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #092C4C99;
    }

    .el-input-group__prepend {
        border-radius: 10px 0 0 10px;
    }

    &.el-input-group--prepend {
        .el-input__inner {
            border-radius: 0 10px 10px 0;
            border-left: none;
        }
    }

}

.el-textarea::v-deep {
    .el-textarea__inner {
        border: 1px solid #bdbdbd;
        border-radius: 10px;
        box-sizing: border-box;
        font-size: 14px;
        outline: none;
        padding: 10px 15px !important;
        border-radius: 10px;
        font-family: 'Inter';
        font-weight: 400;
    }
}

.el-input__inner::placeholder, .el-textarea__inner::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #092C4C !important;
}

.el-input__inner:-ms-input-placeholder, .el-textarea__inner:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #092C4C99;
}

.el-button {
    font-size: 1rem;
    height: 55px !important;
    border-radius: 10px;
}

.el-button.el-button--default.is-disabled {
    background-color: #97c0f6;
    border-color: #97c0f6;
    color: white;
}

.el-button--primary{
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mb-20 {
    margin-bottom: 20px;
}

.no-m {
    margin: 0;
}

.mt-0 {
    margin-top: 0;
}

</style>
